export const dashboardConstants = {
  GET_DASHBOARD_STATS: "GET_DASHBOARD_STATS",
  GET_DASHBOARD_RECRUITER_STATS: "GET_DASHBOARD_RECRUITER_STATS"
};
